import React from 'react'
import PaidLeaveSummary from '../calendar/PaidLeaveSummary'
import JobProtectedLeaveSummary from '../calendar/JobProtectedLeaveSummary'
import ScheduleBenefit from './ScheduleBenefit'

class ScheduleBenefits extends React.Component {
    constructor(props) {
      super(props)
      this.state = {
        icon: 'fa fa-angle-down',
        benefit_header_class: ''
      };
    }

    includeBenefits() {
      if ((this.props.benefits.job_protected_benefits.length > 0) || (this.props.benefits.paid_benefits.length > 0)) {
        return 'benefits-included';
      } else {
        return '';
      }
    }

    showBenefits() {
      const { benefit_header_class } = this.state;
      if (benefit_header_class === 'shown') {
        this.setState({icon: 'fa fa-angle-down', benefit_header_class: ''});
        window.removeEventListener('click', this.hideLeaveComponent, true);
      } else {
        this.setState({icon: 'fa fa-angle-up', benefit_header_class: 'shown'});
        window.addEventListener('click', this.hideLeaveComponent.bind(this), true);
      }
    }

    hideLeaveComponent(e) {
      const component = $(e.target).closest('.benefits');
      if (!component.length || !component.hasClass('shown')) {
        window.removeEventListener('click', this.hideLeaveComponent.bind(this), true);
        this.setState({icon: 'fa fa-angle-down', benefit_header_class: ''});
        return this.props.handleItemClick('', '', '', '');
      }
    }

    renderBenefitTable() {
      if(this.state.benefit_header_class === 'shown'){
        let result = [];
        let result1 = [];;
        let benefit

        for (benefit of Array.from(this.props.benefits.paid_benefits)) {
          result.push(<ScheduleBenefit
            data={benefit} 
            key={benefit.id} 
            icon='paid-benefit' 
            class_name='paid'
            handleItemClick={this.props.handleItemClick} 
            display_modal={this.props.display_modal}
            onHelpfulCheck={this.props.onHelpfulCheck} 
            handleJustLookingClick={this.props.handleJustLookingClick}/>)
        }

        for (benefit of Array.from(this.props.benefits.job_protected_benefits)) {
          result1.push(<ScheduleBenefit
            data={benefit} 
            key={benefit.id} 
            icon='job-protected-benefit' 
            class_name='job_protected' 
            handleItemClick={this.props.handleItemClick} 
            display_modal={this.props.display_modal} 
            onHelpfulCheck={this.props.onHelpfulCheck} 
            handleJustLookingClick={this.props.handleJustLookingClick}/>)
        }
        return(
          <table className="benefits-list">
            <thead/>
            <tbody>
              { result }
              { result1 }
            </tbody>
          </table>
        );
      }
    }

    render() {
      let includeBenefitContent = ''
      if(this.includeBenefits()){
        includeBenefitContent = (
          <div>
            <div className={`benefit-header ${this.includeBenefits()}`} onClick={this.showBenefits.bind(this)}>
              <PaidLeaveSummary
              benefits={this.props.benefits}/>

              <JobProtectedLeaveSummary
              benefits={this.props.benefits}/>

              <div className='benefit-covered-text-wrap'>
                <span className='benefit-covered-text'>
                  Leave Components
                </span>
                <span className={`show-hide-icon ${this.state.icon}`}></span>
              </div>
            </div>
            { this.renderBenefitTable() }
          </div>
          );
          }    
      return (
        <div className={`benefits ${this.state.benefit_header_class}`}>
          {includeBenefitContent}
        </div>
      );
    }
}

export default ScheduleBenefits
